module.exports = __webpack_public_path__ + "static/media/weth.9bcad30a.png";